import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export const Index = {
    auth: authRoles.admin,
    routes: [
        {
            path: '/processed-fluid-close-day',
            component: FuseLoadable({ loader: () => import('./ProcessedFluidCloseDayApp') }),
        },
    ],
};

export default [Index];
